import React from 'react';

import classNames from 'classnames';

import { AttentionIcon } from '../icons/AttentionIcon';

import styles from './NotificationBlock.module.scss';

type NotificationBlockProps = {
	className?: string;
	children: React.ReactNode;
	icon?: JSX.Element;
};

export const NotificationBlock: React.FC<NotificationBlockProps> = ({
	className,
	icon = <AttentionIcon />,
	children,
}) => {
	return (
		<div className={classNames(styles.root, className)}>
			<div className={styles.icon}>{icon}</div>
			{children}
		</div>
	);
};
